import { ListItem } from 'components/List'
import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { roomType } from '../../../data/models/funnelOrder/roomType'
import { AppState } from '../../../data/state'

interface PrivateRoomSummaryProps {
  roomType: roomType
  privateRoom: boolean
}

const PrivateRoomSummary: React.FC<PrivateRoomSummaryProps> = props => {
  return (
    <>
      {props.roomType === roomType.budget && props.privateRoom ? (
        <ListItem>
          <DisplayContent addNode contentKey="private-room-summary">
            Private Room
          </DisplayContent>
        </ListItem>
      ) : null}
    </>
  )
}

export default connect((state: AppState) => ({
  roomType: state.funnelOrder.roomType,
  privateRoom: state.funnelOrder.privateRoom,
}))(PrivateRoomSummary)
